const QUIZ_PREFIX = 'quiz_';

export interface QuizQuestion {
  nodeId: string;
  nodeTitle: string;
  type: 'closed' | 'open';
  front: string;
  back: string;
  userAnswer?: string;
  isCorrect?: boolean;
}

export interface QuizSession {
  id: string;
  date: string;
  config: { count: number; type: 'closed' | 'open' | 'mixed' };
  questions: QuizQuestion[];
  score: { correct: number; total: number };
}

interface QuizData {
  reviewQueue: QuizQuestion[];
  sessions: QuizSession[];
}

const load = (mapId: string): QuizData => {
  try {
    const raw = localStorage.getItem(QUIZ_PREFIX + mapId);
    return raw ? JSON.parse(raw) : { reviewQueue: [], sessions: [] };
  } catch {
    return { reviewQueue: [], sessions: [] };
  }
};

const save = (mapId: string, data: QuizData): void => {
  localStorage.setItem(QUIZ_PREFIX + mapId, JSON.stringify(data));
};

export const getReviewQueue = (mapId: string): QuizQuestion[] =>
  load(mapId).reviewQueue;

export const getQuizSessions = (mapId: string): QuizSession[] =>
  load(mapId).sessions;

export const saveQuizSession = (mapId: string, session: QuizSession): void => {
  const data = load(mapId);

  const correctNodeIds = new Set(
    session.questions.filter(q => q.isCorrect).map(q => q.nodeId)
  );
  const wrongQuestions = session.questions.filter(q => !q.isCorrect);

  const filteredQueue = data.reviewQueue.filter(q => !correctNodeIds.has(q.nodeId));
  const existingIds = new Set(filteredQueue.map(q => q.nodeId));
  const newWrong = wrongQuestions.filter(q => !existingIds.has(q.nodeId));

  save(mapId, {
    reviewQueue: [...filteredQueue, ...newWrong],
    sessions: [session, ...data.sessions].slice(0, 20),
  });
};
